import React from "react";
import { Link } from "react-router-dom";
import { openModal } from "../../../../../Library/ModalPopUp";
const HeaderNavBack = ({ title, url }) => {
  return (
    <div className="mb-8 ">
      <h3 className="mb-0">{title}</h3>
      <Link to={url} className="text-muted text-hover-warning">
        <span className="d-flex align-items-center">
          <i className="fas fa-arrow-left mr-2 "></i>
          <span className="h4 mb-0 font-weight-normal">Back</span>
        </span>
      </Link>
    </div>
  );
};

const CardSessionStatus = ({ data, setData }) => {
  return (
    <div className="title-atd d-flex justify-content-between align-items-center mb-5">
      <h3 className="d-flex align-items-start flex-column">
        <span className="card-label font-weight-bolder text-dark">
          Session Class Attendance
        </span>
        <span className="text-muted mt-3 font-weight-bold font-size-sm">
          List of your session
        </span>
      </h3>
      <div className="form-group mb-0">
        <label className="font-weight-bold">
          Choose Status
          <span className="text-danger">*</span>
        </label>
        <select
          name="FStatus"
          className="form-control form-control-sm"
          onChange={(e) => setData(e.target.value)}
          defaultValue={data}
        >
          <option value="">Choose Status Session</option>
          <option value="3">Submitted</option>
          <option value="4">Approved</option>
          <option value="5">Submitted/Approved</option>
        </select>
      </div>
    </div>
  );
};

const How2UseQR = () => {
  return (
    <div className="info-qr border rounded p-5 mr-5">
      <h3 className="d-flex align-items-start flex-column">
        <span className="card-label font-weight-bolder text-dark">
          How to generate QR
        </span>
        <span className="text-muted mt-3 font-weight-bold font-size-sm">
          Please follow the instruction
        </span>
      </h3>
      <ol type="1">
        <li>Go to Dashboard menu</li>
        <li>In Your Time Table Widget, please choose one the subject</li>
        <li>Please submit the Teaching Topic (if available)</li>
        <li>
          Click button "Show Attendance QR Code" (available only if already
          submit the teaching topic)
        </li>
        <li>And it will show a new window for QR Code</li>
        <li>
          For more information please see the video by{" "}
          <a
            href="https://www.youtube.com/watch?v=1---akiLPs0"
            target="_blank"
          >
            click here
          </a>
        </li>
      </ol>
    </div>
  );
};

const OpenLocation = ({ data }) => {
    if (data.coordinate) {
        let coordinate = data.coordinate;
        let coordinateType = "";
        if (coordinate) {
            let coordinateArr = coordinate.split(",");
            coordinateType = coordinateArr[0] + "," + coordinateArr[1];
        }
        return (
            (coordinateType !== "0,0") ? (
                <a href={"https://www.google.com/maps/search/?api=1&query=" + coordinateType} target="_blank" title='Open map' className="btn btn-sm btn-light d-flex align-items-center py-1 px-3">
                    <i className="fas fa-map-marker-alt text-success icon-sm"></i>
                    <span className="font-weight-bold">Open</span>
                </a>
            ) : (
                <div>
                    <span className="fw-bolder me-1">Location:</span>
                    <span className="text-danger">{coordinateType}</span>
                </div>
            )
        )
    } else {
        return "";
    }
}

const ConfirmAtd = ({ submit }) => {
  return (
    <div className="text-center">
      <p className="font-size-h4">
        Saving this attendance list will <span className="text-danger">disable</span> the QR scan. <br/>
        This is to prevent unauthorized changes on the attendance data that has been finalized by the lecturers. <br/>
        After saving, lecturers can still edit the attendance data manually. Do you want to continue ?
      </p>
      <div className="btn-groups mt-10">
        <button className="btn btn-lg btn-light mr-8" type='button' onClick={() => openModal({ open: false })}>No</button>
        <button className="btn btn-lg btn-primary" type='button' onClick={() => submit()}>Yes</button>
      </div>
    </div>
  )
}

export { HeaderNavBack, CardSessionStatus, How2UseQR, OpenLocation, ConfirmAtd };
